import moment from 'moment';
import { joinedValuesSeparator, dateTimeFormat } from '@/ts/DefaultTableConfigs';

export default class PresentationApplicationsData {
    public id: number;
    public name: string;
    public email: string;
    public phone: string;
    public language: string;
    public priority: string;
    public interestedFrom: string;
    public createdAt: string;
    public gender: string;
    public age: any;
    public nationality: string;
    public educationTags: any;
    public interestsTags: any;
    public aboutMe: string;
    public applicationMotivation: string;
    public minSize: number;
    public maxSize: number;
    public minRent: number;
    public maxRent: number;
    public numberOfRooms: number;
    public optionAnswers: any;

    constructor(
        id: number,
        firstName: string,
        lastName: string,
        email: string,
        phone: string,
        language: string,
        priority: string,
        interestedFrom: string,
        createdAt: string,
        gender: string,
        age: any,
        nationality: string,
        educationTags: any,
        interestsTags: any,
        aboutMe: string,
        applicationMotivation: string,
        otherInterests: string,
        minSize?: number,
        maxSize?: number,
        minRent?: number,
        maxRent?: number,
        numberOfRooms?: number,
        optionAnswers?: any,
    ) {
        this.id             = id;
        this.name           = `${firstName} ${lastName}`;
        this.email          = email;
        this.phone          = phone;
        this.language       = language === 'dk' ? 'DA' : 'EN';
        this.priority       = priority === 'on' ? 'Yes' : 'No';
        this.interestedFrom = interestedFrom !== null ? interestedFrom : '';
        this.createdAt      = createdAt !== null ? moment(createdAt).local().format(dateTimeFormat) : '';
        this.gender         = gender !== null ? gender : '';
        this.age            = age !== null ? age : '';
        this.nationality    = nationality !== null ? nationality : '';
        this.educationTags  = educationTags.join(joinedValuesSeparator);
        this.interestsTags  = interestsTags.join(joinedValuesSeparator);
        this.aboutMe        = aboutMe;
        this.applicationMotivation = applicationMotivation;
        this.minSize               = minSize ? minSize : null;
        this.maxSize               = maxSize ? maxSize : null;
        this.minRent               = minRent ? minRent : null;
        this.maxRent               = maxRent ? maxRent : null;
        this.numberOfRooms         = numberOfRooms ? numberOfRooms : null;
        this.optionAnswers         = optionAnswers ? optionAnswers.sort((a: any, b: any)=> a.localeCompare(b)).join(joinedValuesSeparator) : null;
    }
}
